import { render, staticRenderFns } from "./CreateDirectoryLevel2.vue?vue&type=template&id=b0ad1242&scoped=true&"
import script from "./CreateDirectoryLevel2.vue?vue&type=script&lang=ts&"
export * from "./CreateDirectoryLevel2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ad1242",
  null
  
)

export default component.exports